import { render, staticRenderFns } from "./TemplateMessageModal.vue?vue&type=template&id=df0bdbf6&"
import script from "./TemplateMessageModal.vue?vue&type=script&lang=js&"
export * from "./TemplateMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports